__turbopack_context__.v({
  "bar": "_375xyG_bar",
  "criteriaIcon": "_375xyG_criteriaIcon",
  "criteriaItem": "_375xyG_criteriaItem",
  "criteriaList": "_375xyG_criteriaList",
  "fill": "_375xyG_fill",
  "medium": "_375xyG_medium",
  "status": "_375xyG_status",
  "strong": "_375xyG_strong",
  "weak": "_375xyG_weak",
});
